export enum ORIENTATION_ANGLE {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export const USER_INFO = {
  NAME: { key: 'NAME', value: 'my-profile.user-info.name' },
  EMAIL: { key: 'EMAIL', value: 'my-profile.user-info.email' },
  PASSWORD: { key: 'PASSWORD', value: 'my-profile.password' },
};

export enum USER_PROVIDER {
  LOCAL = 'local',
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  ZALO = 'zalo',
}
